export function parseTime(time, cFormat) {
	if (arguments.length === 0) {
		return null
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
		const value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		return value.toString().padStart(2, '0')
	})
	return time_str
}
export function toDate(sTime) {
	if (sTime) {
		var st = sTime
		var a = st.split(' ')
		var b = a[0].split('-')
		var date = new Date(b[0], b[1] - 1, b[2])
		return date
	}
}

export function toDateTime(sTime) {
	if (sTime) {
		var st = sTime
		var a = st.split(' ')
		var b = a[0].split('-')
		var c = a[1].split(':')
		var date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2])
		return date
	}
}
export function formatDate(time) {
  return parseTime(time, '{y}-{m}-{d}')
}